
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M23.5 23H.5a.5.5 0 000 1h23a.5.5 0 000-1z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M4.5 17h-3a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zM4 23H2v-5h2v5zM10.5 12h-3a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zM10 23H8V13h2v10zM16.5 14h-3a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5zm-.5 9h-2v-8h2v8zM22.5 8h-3a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5zM22 23h-2V9h2v14z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M3 9c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 3a1.001 1.001 0 010-2 1.001 1.001 0 010 2zM9 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 3a1.001 1.001 0 010-2 1.001 1.001 0 010 2zM15 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 3a1.001 1.001 0 010-2 1.001 1.001 0 010 2zM21 0c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 3a1.001 1.001 0 010-2 1.001 1.001 0 010 2z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M20.294 2.706a.5.5 0 00-.707 0l-3.88 3.88a.5.5 0 00.707.707l3.88-3.88a.5.5 0 000-.707zM13.791 6.846l-3.212-.916a.5.5 0 00-.274.962l3.212.916a.504.504 0 00.618-.344.5.5 0 00-.344-.618zM8.22 6.623a.5.5 0 00-.702-.08l-3.77 3.006a.5.5 0 00.623.783l3.77-3.006a.5.5 0 00.079-.703z","fill":"#00003C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    